module.exports = __webpack_public_path__ + "static/img/CreationHomes.40014c98.png";